module.exports = __webpack_public_path__ + "static/media/FiraSans-Bold.00e640b1.ttf";